module.exports = __webpack_public_path__ + "img/camera.f6207e92.svg";